import { Component } from '@angular/core';
import { ModalComponent } from 'app/shared/modal-service/modal.service';
import { ProductCustomerSizeModel } from 'app/shared/notes/models/product-customer-size-model';
import { NgModel, NgForm } from '@angular/forms';
import { ProductCustomerSizeService } from 'app/shared/notes/product-customer-size.service';

@Component({
  selector: 'app-product-customer-size',
  templateUrl: './product-customer-size.component.html',
  styleUrls: ['./product-customer-size.component.css']
})
export class ProductCustomerSizeComponent extends ModalComponent<ProductCustomerSizeModel>{
  data: ProductCustomerSizeModel;
  private customerSizeService: ProductCustomerSizeService
  init(arg: ProductCustomerSizeModel, service: ProductCustomerSizeService) {
    this.data = arg;
    this.customerSizeService = service;
  }
 
  onBlur(ngmodel: NgModel) {
    this.customerSizeService
      .CustomerSizeOffsetValidity(this.data.mym, this.data.productIds,
        this.data.frontOffset, this.data.rearOffset, this.data.isAggressive, ngmodel.name).then(invalid => {
          if (invalid === true) {
            ngmodel.control.setErrors({ 'invalidoffset': true, 'requiredValue': 'No' });
            return { 'invalidoffset': true, 'requiredValue': 'No' };
          }
        });
  }

  close(f: NgForm) {
    this.customerSizeService
      .CustomerSizeOffsetValidity(this.data.mym, this.data.productIds,
        this.data.frontOffset, this.data.rearOffset, this.data.isAggressive, '').then(invalid => {
          if (invalid === true) {
            f.form.setErrors({ 'invalidoffset': true, 'requiredValue': 'No' });
            return { 'invalidoffset': true, 'requiredValue': 'No' };
          }
          else {
            this.modalRef.close(this.data);
          }
        });
  }
}
